module.exports = __webpack_public_path__ + "img/p3-1.73a6da06.png";